import { Lock, Bell } from 'lucide-react';
import PlanGate from '../../../../../../components/gating/PlanGate';

const SendNotificationCard = ({ handlePingUser, setNotificationType }) => {
  return (
    <PlanGate
      requiredPlan="pro"
      featureName="Send Notifications"
      tooltipText="Sending guest notifications requires the Pro Plan."
      showLockIcon={false}
      wrapperClassName="w-full h-full flex flex-col"
    >
      {({ isLocked, onClick }) => (
        <div className="vc-card relative h-full flex-1 flex flex-col">
          <div className="vc-card-head flex items-center justify-between pb-2 border-b border-slate-100">
            <h3 className="flex items-center gap-2 text-sm font-medium text-slate-600 tracking-tight">
              <span className="w-7 h-7 rounded-lg bg-teal-50 border border-teal-100 flex items-center justify-center shrink-0">
                <Bell size={15} className="text-[#067978]" />
              </span>
              <span>Send Notifications</span>
            </h3>
            {isLocked && <Lock size={13} className="text-slate-400" />}
          </div>

          <div
            className="vc-comm vc-lead flex items-center justify-between cursor-pointer"
            onClick={
              isLocked
                ? onClick
                : () => {
                    setNotificationType("welcome");
                    handlePingUser(null);
                  }
            }
          >
            <span>Welcome message</span>
            {isLocked ? <Lock size={12} className="text-slate-400" /> : <span className="vc-arr">&rarr;</span>}
          </div>

          <div
            className="vc-comm flex items-center justify-between cursor-pointer"
            onClick={
              isLocked
                ? onClick
                : () => {
                    setNotificationType("reminder");
                    handlePingUser(null);
                  }
            }
          >
            <span>Trip reminder</span>
            {isLocked ? <Lock size={12} className="text-slate-400" /> : <span className="vc-arr">&rarr;</span>}
          </div>

          <div
            className="vc-comm flex items-center justify-between cursor-pointer"
            onClick={
              isLocked
                ? onClick
                : () => {
                    setNotificationType("update");
                    handlePingUser(null);
                  }
            }
          >
            <span>Flight / hotel update</span>
            {isLocked ? <Lock size={12} className="text-slate-400" /> : <span className="vc-arr">&rarr;</span>}
          </div>

          <div
            className="vc-comm border-t border-dashed border-[#e7ecea] pt-2 flex items-center justify-between cursor-pointer"
            onClick={
              isLocked
                ? onClick
                : () => {
                    setNotificationType("custom");
                    handlePingUser(null);
                  }
            }
          >
            <span>Custom message</span>
            {isLocked ? <Lock size={12} className="text-slate-400" /> : <span className="vc-arr">&rarr;</span>}
          </div>
        </div>
      )}
    </PlanGate>
  );
};

export default SendNotificationCard;
